import { QueryClient } from "@tanstack/react-query";

/**
 * Shared React Query client.
 * Import this anywhere you need to imperatively invalidate or prefetch.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Re-fetch stale data in the background when window regains focus
      refetchOnWindowFocus: true,
      // Retry once on failure before marking as error
      retry: 1,
      // Data is considered fresh for 2 minutes
      staleTime: 2 * 60 * 1000,
      // Cache data for 5 minutes after all subscribers unmount
      gcTime: 5 * 60 * 1000,
    },
    mutations: {
      retry: 0,
    },
  },
});
